<template>
  <div
    id="app"
    :class="{ buying: $route.path === '/buying' || $route.path === '/search', [lang]: lang}"
  >
    <header>
      <img :src="imgSrc.title ? imgSrc.title.titleImg : ''" class="header-bg" />
      <div class="header-info">
        <LangSwitch />
        <!--  v-if="token" -->
        <Logout v-if="token && $route.path !== '/thirdPartChannel'" />
        <s-help
          :text="$t('login_tip')"
          v-if="$route.path === '/thirdPartChannel' && !isPc"
          class="help-login--mobile"
        />
      </div>
    </header>
    <div class="body">
      <img
        src="@/static/assets/ui/pc/logo.png"
        class="img-logo"
        v-if="$route.path === '/thirdPartChannel'"
      />
      <s-help
        :text="$t('login_tip')"
        v-if="$route.path === '/thirdPartChannel' && isPc"
        class="help-login"
      />
      <RouterViewParent />

    </div>
    <div class="copyright" v-if="!['/buying', '/search'].includes($route.path)">
      <img src="@/static/assets/ui/pc/logo-clicktouch.png" alt="" />
      <div>
        Copyright © 2021 Clicktouch Technology International Company Limited. All rights reserved.
      </div>
    </div>
    <ButtomInfo v-if="isPc && $route.path === '/buying'" />
    <!-- <router-link to="/thirdPartChannel">登陆渠道thirdPartChannel</router-link> ||
    <router-link to="/roleBinding">绑定角色</router-link> ||
    <router-link to="/infoBinding">选择区服角色</router-link> ||

    <router-link to="/loginFail">登陆失败</router-link> ||
    <router-link to="/buying">快速购买</router-link> || -->
  </div>
</template>

<script>
import pcMulLangUrlConfig from '@/config/pc/distUrl'
import mobileMulLangUrlConfig from '@/config/mobile/distUrl'
import { publicUrlConfig } from '@/config/public'
import langList from '@/config/lang'
import { mapMutations, mapState } from 'vuex'
import { googleLogin, fbLogin } from '@/api/login'
import RouterViewParent from '@/views/routerViewParent'
import Logout from './views/header/Logout'
import LangSwitch from './views/header/LangSwitch'
import ButtomInfo from './views/buying/BottomInfo'

export default {
  name: 'App',
  components: {
    RouterViewParent,
    Logout,
    LangSwitch,
    ButtomInfo
  },
  data () {
    return {
      imgSrc: {},
      pcMulLangUrlConfig,
      mobileMulLangUrlConfig,
      langList,
      currentLang: langList[0].value
    }
  },
  computed: {
    ...mapState([
      'isPc',
      'token',
      'lang'
    ]),
    localeLang () {
      return this.$store.state.lang
    },
    publicImgPath () {
      return publicUrlConfig[this.isPc ? 'pc' : 'mobile']
    }
  },
  created () {
    this.thirdPartVerification()
  },
  mounted () {
    this.checkHistory()
    this.init()
  },
  watch: {
    '$store.state.lang': function (lang) {
      const documentElement = document.documentElement
      const winWidth = documentElement.clientWidth
      if (winWidth <= 750) {
        this.imgSrc = this.mobileMulLangUrlConfig[lang]
      } else {
        this.imgSrc = this.pcMulLangUrlConfig[lang]
      }
    },
    currentLang (lang) {
      this.changeLang(lang)
    }
  },
  methods: {
    ...mapMutations([
      'SET_PC_STATUS',
      'SET_TOKEN'
    ]),
    init () {
      const documentElement = document.documentElement
      const winWidth = documentElement.clientWidth
      documentElement.style.fontSize = winWidth / 100 + 'px'

      // const mainDomEle = document.querySelector('#main-body')
      if (winWidth <= 750) {
        if (this.isPc || this.isPc === undefined) {
          this.SET_PC_STATUS(false)
        }
        this.imgSrc = this.mobileMulLangUrlConfig[this.localeLang]
        // mainDomEle.style.minHeight =
        //   window.screen.height -
        //   parseFloat(document.documentElement.style.fontSize) * 56 +
        //   'px'
      } else {
        if (!this.isPc || this.isPc === undefined) {
          this.SET_PC_STATUS(true)
        }
        this.imgSrc = this.pcMulLangUrlConfig[this.localeLang]
        // mainDomEle.style.minHeight = document.body.offsetHeight - 616 + 'px'
      }
    },
    constructRouteQuery () {
      const queryString = location.search.slice(1)
      const regExp = /(.+?)=([^&]+)&?/g
      const queryObj = {}
      let matchArr
      while ((matchArr = regExp.exec(queryString)) !== null) {
        const key = matchArr[1]
        const value = matchArr[2]
        queryObj[key] = value
      }
      return queryObj
    },
    // 登陆
    async thirdPartVerification () {
      const queryObj = this.constructRouteQuery()
      const authCode = decodeURIComponent(queryObj.code)
      const loginChannelName = queryObj.state

      const redirectUri = process.env.VUE_APP_ORIGIN
      if (authCode && redirectUri && loginChannelName) {
        let code, data
        if (loginChannelName === 'Google') {
          const response = await googleLogin({
            code: authCode,
            redirect_uri: redirectUri
          })
          code = response.code
          data = response.data
        } else if (loginChannelName === 'FB') {
          const response = await fbLogin({
            code: authCode,
            redirect_uri: redirectUri
          })
          code = response.code
          data = response.data
        }
        if (code === 0 && data.token) {
          console.log('app init====')
          this.SET_TOKEN(data.token)
          this.$router.replace({ path: '/roleBinding' })
        }
      }
    },
    // back () {
    //   if (sessionStorage.afterRecharge === '1') {
    //     const taiHistoryArr = JSON.parse(sessionStorage.taiHistoryArr)
    //     const path = taiHistoryArr.pop()
    //     if (path) {
    //       this.$router.push(path)
    //     }
    //     // sessionStorage.taiHistoryArr = JSON.stringify(taiHistoryArr)
    //   } else {
    //     this.$router.back()
    //   }
    // },
    checkHistory () {
      if (history.length === 1) {
        sessionStorage.removeItem('afterRecharge')
        const path =
          location.pathname === '/' ? '/thirdPartChannel' : location.pathname
        console.log(JSON.stringify([path]))
        sessionStorage.taiHistoryArr = JSON.stringify([path])
      }
    }
  }
}
</script>
<style lang="less" scoped>
#app {
  display: flex;
  flex-flow: column;
  width: 100%;
  font-family: Arial;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  font-size: 16px;
  // min-height: 890px;
  overflow: hidden;
  background: url("./static/assets/ui/pc/bg.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  min-width: 1300px;
  min-height: 100vh;
  &.buying {
    background-image: url(./static/assets/ui/pc/bg-buying.png);
    background-size: 100% 100%;
    /deep/ .bottom-info {
    //       position: absolute;
    // bottom: 0;
    }
  }
  header {
    position: relative;
    z-index: 10;
    .header-bg {
      width: 100%;
    }
    .header-info {
      display: flex;
      position: absolute;
      align-items: center;
      // top: 24px;
      right: 232px;
      right: 232px;
      top: 50%;
      transform: translateY(-93%);
    }
    .lang-switcher {
      margin-right: 20px;
    }
  }
  .body {
    flex: auto;
    position: relative;
    width: 100%;
    // height: 100%;
    text-align: center;
    top: -33px;
    // overflow: auto;
    // min-height: calc(100vh - 268px) !important;
    .img-bg {
      position: absolute;
      left: 0;
      top: -92px;
      width: 100%;
      z-index: -1;
    }

    .img-logo {
      margin-top: 100px;
    }
    .help-login {
      margin-bottom: 52px;
    }
  }
  .copyright {
    // position: fixed;
    // bottom: 0;
    color: #d7d7d7;
    width: 100%;
    margin-bottom: 26px;
    text-align: center;
    img {
      margin-bottom: 8px;
    }
  }
}
@media screen and (max-height: 500px){
  .copyright {
    display: none;
  }
}
@media screen and (max-width: 750px) {
  #app {
    // font-size: 2.1333rem;
    background-image: url("./static/assets/ui/mobile/bg.jpg");
    // min-height: 100;
    min-width: auto;
    min-height: 100vh;
    overflow: auto;
    &.buying {
      background-image: url(./static/assets/ui/mobile/bg-buying.jpg);
      background-size: 100% 100%;
    }
    &.en_us {
      /deep/ .lang-switcher {
        margin-right: 5px;
      }
      /deep/ .logout {
        padding: 0 1rem;
      }
    }
    header {
      .header-info {
        right: 4rem;
        // top: 4rem;
      }
    }
    .body {
      margin-top: 0;
      top: -4.4rem;
      height: calc(100vh - 14.2667rem /* 107/7.5 */) !important;
      .img-logo {
        width: 48.8rem;
        margin-top: 22rem;
      }
      .img-bg {
        top: -19rem;
      }
    }
    .copyright {
      position: fixed;
      bottom: 0;
      margin-block: 5.0667rem;
      font-size: 2.1333rem;
      img {
        width: 24.6667rem;
        height: 6.8rem;
      }
    }
  }
}
</style>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
* {
  box-sizing: border-box;
}
html,
body {
  margin: 0;
  padding: 0;
}

body {
  min-height: 100vh;
  display: flex;
  background-color: #221f1e;
}
div {
  user-select: none;
}
::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}
::-webkit-scrollbar-thumb {
  background-color: #aaa;
}
input{
    -webkit-appearance: none;
}
</style>
